import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CompanyResponsibleDto } from 'src/app/domain/models/dto/company-responsible.dto';
import { CreateCompanyResponsibleDto } from 'src/app/domain/models/dto/create-company-responsible.dto';
import { PersonalCheckDto } from 'src/app/domain/models/dto/personal-check.dto';
import { UpdateCompanyResponsibleDto } from 'src/app/domain/models/dto/update-company-responsible.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '.';

@Injectable({
  providedIn: 'root',
})
export class CompanyResponsibleService {
  private listener: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthenticationService
  ) { }

  getByCompany() {
    return this.http.get<ResponseObjectModel<CompanyResponsibleDto[]>>(
      `${environment.API_BASE_URL}/v1/company-responsibles/corporate-accounts/${this.authService.getCompanyId()}`
    );
  }

  validateSituation(companyResponsibleId: number) {
    return this.http.get<ResponseObjectModel<PersonalCheckDto>>(
      `${environment.API_BASE_URL}/v1/company-responsibles/${companyResponsibleId}/personal-checks/validate`
    );
  }

  get listenerUpdate() {
    return this.listener.asObservable();
  }

  updateResponsibleView() {
    this.listener.next(true);
  }

  public uploadDocumentFile(id: number, file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.put<ResponseObjectModel<CompanyResponsibleDto>>(
      `${environment.API_BASE_URL}/v1/company-responsibles/${id}/document-file`,
      formData
    );
  }

  register(companyResponsibleDto: CreateCompanyResponsibleDto) {
    return this.http.post<ResponseObjectModel<CompanyResponsibleDto>>(
      `${environment.API_BASE_URL}/v1/company-responsibles`,
      companyResponsibleDto
    );
  }

  update(id: number, companyResponsibleDto: UpdateCompanyResponsibleDto) {
    return this.http.put<ResponseObjectModel<CompanyResponsibleDto>>(
      `${environment.API_BASE_URL}/v1/company-responsibles/${id}`,
      companyResponsibleDto
    );
  }

  delete(id: number) {
    return this.http.delete<ResponseObjectModel<any>>(
      `${environment.API_BASE_URL}/v1/company-responsibles/${id}`
    );
  }

  deleteFatca(id: number) {
    return this.http.delete<ResponseObjectModel<any>>(
      `${environment.API_BASE_URL}/v1/company-responsibles/${id}/fatca`
    );
  }
}
